import actions from "./actions";

const { FETCH_RESULT, FETCH_RESULTS, RESET_RESULT } = actions;

const initState = {
    results: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    result: { _id: null }
};

const ResultReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_RESULTS:
            return {
                ...state,
                results: data
            };
        case RESET_RESULT:
            return {
                ...state,
                result: initState.result
            };
        case FETCH_RESULT:
            return {
                ...state,
                result: data
            };
        default:
            return state;
    }
}

export default ResultReducer;
